import { useState } from "react";

function useModal() {
  const [model, setModel] = useState({ open: false });
  const showModal = (oModel) => {
    setModel({ open: true, ...oModel }); // considerar cambiar
  };

  return [model, showModal];
}

export { useModal };
